import { render, staticRenderFns } from "./DimensionsComboBox.vue?vue&type=template&id=c5ba4df4&scoped=true&"
import script from "./DimensionsComboBox.vue?vue&type=script&lang=js&"
export * from "./DimensionsComboBox.vue?vue&type=script&lang=js&"
import style0 from "./DimensionsComboBox.vue?vue&type=style&index=0&id=c5ba4df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba4df4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCombobox,VListItem,VListItemContent,VListItemTitle,VTooltip})
